import React from "react";
import Typography from "@material-ui/core/Typography";
import CardMedia from "@material-ui/core/CardMedia";
import useStyles from "./style/style";
import RumahZakatImg from "../../../assets/images/rumah-zakat.png";

function RumahZakat() {
  const classes = useStyles();
  return (
    // <Card>
    //   <CardActionArea
    //     onClick={() =>
    //       window.open("https://www.rumahzakat.org/l/microsite-tokorame/")
    //     }
    //   >
    <div className={classes.rootRmz}>
      <div>
        <Typography
          variant="subtitle1"
          gutterBottom
          style={{ color: "#EB5B19" }}
        >
          Bayar zakat, infak atau dana sosial lainnya
        </Typography>
        <Typography variant="caption">
          Belum bayar zakat atau ingin beramal? Kamu juga bisa bayar zakat,
          infak, sedekah, wakaf atau amal melalui Tokorame.
          <span
            style={{
              color: "#5675D3",
              fontWeight: "bold",
              textDecorationLine: "underline",
              cursor: "pointer",
            }}
            onClick={() =>
              window.open("https://www.rumahzakat.org/l/microsite-tokorame/")
            }
          >
            Yuk, beramal sekarang!
          </span>{" "}
        </Typography>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CardMedia image={RumahZakatImg} className={classes.logosrmz} />
      </div>
    </div>
    //   </CardActionArea>
    // </Card>
  );
}

export default RumahZakat;
